<template>
  <div style="padding-bottom: 40px">
    <div class="category_container">
      <v-layout column>
        <v-flex>
          <v-switch
            v-model="computedChooseCategory"
            label="Send invitation with a pre-defined attendee category"
          />
          <p style="padding-bottom: 10px">
            When enabled, the invitation is sent with a category pre-selected by the organizer. When disabled, attendees choose their own category during registration.
          </p>
        </v-flex>
        <v-flex v-if="!predefinedCategory" style="padding-top: 30px">
          <select-field
            v-model="computedCategory"
            :items="categories"
            label="Category"
            item-render="name"
            item-select="id"
          />
        </v-flex>
      </v-layout>
    </div>
  </div>
</template>

<script>
export default {
  name: 'invite-and-share-categories-section',
  props: {
    category: {
      type: String,
      default: null,
    },
    predefinedCategory: {
      type: Boolean,
      default: false,
    },
    categories: {
      type: Array,
      default: () => [],
    },
  },
  emits: ['update:categorySelected', 'update:predefinedCategory'],
  computed: {
    computedCategory: {
      get() {
        return this.category
      },
      set(value) {
        this.$emit('update:categorySelected', value)
      },
    },
    computedChooseCategory: {
      get() {
        return this.predefinedCategory
      },
      set(value) {
        this.$emit('update:predefinedCategory', value)
      },
    },
  },
}
</script>

<style scoped>
.category_container {
  background-color: white;
  border: 1px solid #D9D9D9;
  width: 100%;
  max-width: 488px;
  border-radius: 10px 10px 10px 10px;
  padding: 20px;
  display: flex;
  gap: 20px;
  flex-direction: column;
}

.category_container p {
  color: #979797;
  margin: 0;
  padding: 0;
}
</style>
